import React, { useEffect } from "react";
import "../checkOut/checkOut.scss";
import { CustomEvent, serviceCall } from "../../Utils/ServiceUtils";
import { Link } from "react-router-dom";

function PaymentSuccess() {

    useEffect(() => {
        paymentSessionId();
    }, [])

    const paymentSessionId = async () => {
        let sessionID = window.location.search.split("?session_id=")[1];
        if(sessionID) {
            window.localStorage.setItem("CartDetails",JSON.stringify([]));
            window.dispatchEvent(CustomEvent("storage",{"detail": {"key": "Cart"} }));
            await serviceCall("GET", "/API/Payments/PaymentSuccess?session_id="+sessionID);
            await serviceCall("DELETE", "/API/Cart/EmptyCart");
            window.location.search = "";
        }
    }

    return (
        <>
            <div className="paymentSuccessForm checkOutForm">
                <div id="multi-step-form-container">
                    <form id="userAccountSetupForm" style={{boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.6)"}} className="text-center" name="userAccountSetupForm" >
                            <h2 className="font-normal" style={{marginTop: "76px",padding: "20px"}}>Successfull</h2> 
                            <div className="mt-3">
                                Order has been Placed Successfully.
                            </div>
                             <div className="mt-3 p-4">
                                <Link to="/Home" style={{ textDecoration: "none" }}>
                                    <button className="button submit-btn" type="submit">Home</button>
                                </Link>
                            </div>
                   </form>
                </div>
            </div>
        </>
    );
}

export default PaymentSuccess;